import React from 'react';
import { MenuItem } from 'src/components/enterprise/navigation/NavMenu/MenuItem';

export const ParentAdminLandingMenuItems: React.FC = () => {
  return (
    <>
      <MenuItem
        menu="Parent accounts"
        mainRoute="/corporate/enterprise/parents/accounts"
      />
      <MenuItem
        menu="Corporate accounts"
        mainRoute="/corporate/enterprise/corporations"
      />
    </>
  );
};
